import structureTypes from 'common/constants/structureTypes'
import React from 'react'
import AgreementSettings from './entities/AgreementSettings'
import AudioSettings from './entities/AudioSettings'
import BlogPostContentPlaceholderSettings from './entities/BlogPostContentPlaceholderSettings'
import ButtonSettings from './entities/ButtonSettings'
import CarouselSettings from './entities/CarouselSettings'
import ContentBoxSettingsOld from './entities/ContentBoxSettingsOld'
import CustomerTypeSettings from './entities/CustomerTypeSettings'
import ImageSettings from './entities/ImageSettings'
import InputSettings from './entities/input-settings'
import LanguageSwitcherSettings from './entities/LanguageSwitcherSettings'
import PaymentButtonSettings from './entities/PaymentButtonSettings'
import PaymentMethodSettings from './entities/PaymentMethodSettings'
import RowSettingsOld from './entities/RowSettingsOld'
import SectionSettingsOld from './entities/SectionSettings/SectionSettingsOld'
import StartTimerSettings from './entities/StartTimerSettings'

export default {
  create(type, id, props) {
    let component = null
    switch (type) {
      case structureTypes.SECTION:
        component = SectionSettingsOld
        break
      case structureTypes.ROW:
        component = RowSettingsOld
        break
      case structureTypes.BUTTON:
        component = ButtonSettings
        break
      case structureTypes.FORM_INPUT:
        component = InputSettings
        break
      case structureTypes.IMAGE:
        component = ImageSettings
        break
      case structureTypes.AUDIO:
        component = AudioSettings
        break
      case structureTypes.CONTENT_BOX:
        component = ContentBoxSettingsOld
        break
      case structureTypes.PAYMENT_METHOD:
        component = PaymentMethodSettings
        break
      case structureTypes.CUSTOMER_TYPE:
        component = CustomerTypeSettings
        break
      case structureTypes.PAYMENT_BUTTON:
        component = PaymentButtonSettings
        break
      case structureTypes.START_TIMER:
        component = StartTimerSettings
        break
      case structureTypes.AGREEMENT:
        component = AgreementSettings
        break
      case structureTypes.CAROUSEL:
        component = CarouselSettings
        break
      case structureTypes.BLOG_POST_CONTENT_PLACEHOLDER:
      case structureTypes.BLOG_CONTENT_PLACEHOLDER:
        component = BlogPostContentPlaceholderSettings
        break
      case structureTypes.LANGUAGE_SWITCHER:
        component = LanguageSwitcherSettings
        break
      default:
        component = ''
    }

    return React.createElement(component, props)
  },
}
